"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _TextArea = _interopRequireDefault(require("../../component/TextArea"));

var _react = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _ThemeProvider.createUseStyles)({
  TextAreaWithCount: {
    display: 'inline-flex',
    lineHeight: 'initial',
    flexFlow: 'column',
    textAlign: 'right'
  },
  Counter: {
    marginTop: 10
  }
});

var TextAreaWithCount = function TextAreaWithCount(_ref) {
  var value = _ref.value,
      className = _ref.className,
      maxLength = _ref.maxLength,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["value", "className", "maxLength"]);
  var classes = useStyles();

  var _useState = (0, _react.useState)(new String(value || '').length),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      charCount = _useState2[0],
      setCharCount = _useState2[1];

  (0, _react.useEffect)(function () {
    return setCharCount(new String(value || '').length);
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.TextAreaWithCount, className)
  }, /*#__PURE__*/_react["default"].createElement(_TextArea["default"], (0, _extends2["default"])({
    maxLength: maxLength,
    value: value
  }, rest)), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.Counter
  }, charCount, " / ", maxLength));
};

exports["default"] = TextAreaWithCount;
//# sourceMappingURL=index.js.map